import React from "react";
import {FormattedMessage} from "react-intl";

export default (props) => {
  return (
    <h1 className="page-title">
      <FormattedMessage id="contacts.title" defaultMessage="Contacts"/>
    </h1>
  );
}
